import { BrowserCacheLocation, Configuration, RedirectRequest } from "@azure/msal-browser";
import { env } from "env";

const parseScopes = (raw: string | undefined): string[] => {
  if (!raw) return [];
  return raw
    .split(/[,\s]+/g)
    .map((s) => s.trim())
    .filter(Boolean);
};

const scopes = parseScopes(env.REACT_APP_AUTH_SCOPES);

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: env.REACT_APP_AUTH_CLIENTID,
    authority: env.REACT_APP_AUTH_AUTHORITY,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // This configures where your cache will be stored
  },
};

// Add here scopes for token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes,
};
